import React, { useEffect, useState } from "react";
import { FC } from "react";
import ClearDataButton from "./ClearDataButton";
import ButtonSubmit from "./ButtonSubmit";
import useOutsideAlerter from "hooks/useOutsideAlerter";
import { GuestsObject } from "components/HeroSearchForm/type";
import NcInputNumber from "components/NcInputNumber/NcInputNumber";
import { useAppContext } from "AppContext";

export interface GuestsInputProps {
  className?: string;
  fieldClassName?: string;
  autoFocus?: boolean;
  submitLink: string;
}

const GuestsInput: FC<GuestsInputProps> = ({
  fieldClassName = "[ nc-hero-field-padding--small ]",
  className = "",
  autoFocus = false,
  submitLink,
}) => {
  const refContainer = React.createRef<HTMLDivElement>();
  const [isOpen, setIsOpen] = useState(false);
  useOutsideAlerter(refContainer, () => setIsOpen(false));
  const { updateFilterState, filterState } = useAppContext();
  const [guestAdultsInputValue, setGuestAdultsInputValue] = useState(1);
  const [guestChildrenInputValue, setGuestChildrenInputValue] = useState(0);
  const [guestInfantsInputValue, setGuestInfantsInputValue] = useState(0);

  useEffect(() => {
    setIsOpen(autoFocus);
  }, [autoFocus]);

  const handleChangeData = (value: number, type: keyof GuestsObject) => {
    let newValue = {
      guestAdults: guestAdultsInputValue,
      guestChildren: guestChildrenInputValue,
      guestInfants: guestInfantsInputValue,
    };
    if (type === "guestAdults") {
      setGuestAdultsInputValue(value);
      newValue.guestAdults = value;
      updateFilterState("guestNumber", value)
    }
    if (type === "guestChildren") {
      setGuestChildrenInputValue(value);
      newValue.guestChildren = value;
      updateFilterState("number_of_children", value)
    }
    if (type === "guestInfants") {
      setGuestInfantsInputValue(value);
      newValue.guestInfants = value;
      updateFilterState("number_of_infants", value)
    }
  };

  const handleSubmit = () => {
    updateFilterState("handleSubmit", true)
  }
  useEffect(() => {
    if (filterState?.guestNumber) {
      setGuestAdultsInputValue(filterState?.guestNumber)
    } else {
      setGuestAdultsInputValue(1)
    }
  }, []);

  useEffect(() => {

    if (filterState?.number_of_children) {
      setGuestChildrenInputValue(filterState?.number_of_children)
    } else {
      setGuestChildrenInputValue(0)
    }

  }, []);

  useEffect(() => {

    if (filterState?.number_of_infants) {
      setGuestInfantsInputValue(filterState?.number_of_infants)
    } else {
      setGuestInfantsInputValue(0)
    }
  }, []);

  const totalGuest =
    guestChildrenInputValue + guestAdultsInputValue + guestInfantsInputValue;
  const totalGuests = Number(filterState?.guestNumber || 0) + Number(filterState?.number_of_children || 0);


  return (
    <div className={`flex z-10 relative ${className}`} ref={refContainer}>
      <div
        className={`flex z-10 relative flex-1 text-left justify-between items-center focus:outline-none cursor-pointer ${isOpen ? "nc-hero-field-focused--2" : ""
          }`}
      >
        <div
          className={`${fieldClassName} flex-1 lg:min-w-[200px]`}
          onClick={() => setIsOpen(!isOpen)}
        >
          <div className="flex-1 text-left">
            {totalGuests > 0 && (
              <span style={{ color: "#0c586e" }} className="block font-semibold">
                <span style={{ fontSize: "14px" }}>{totalGuests}</span> {totalGuests === 1 ? "Guest" : "Guests"}
              </span>
            )}
            <span className="block mt-1 text-sm text-neutral-400 leading-none font-light">
              {totalGuests ? "Guests" : "Add guests"}
            </span>
          </div>
        </div>

        <div className="relative">
          {!!totalGuests && isOpen && (
            <ClearDataButton
              onClick={() => {
                setGuestAdultsInputValue(1);
                setGuestChildrenInputValue(0);
                setGuestInfantsInputValue(0);
                updateFilterState("guestNumber", 1)
                updateFilterState("number_of_infants", 0)
                updateFilterState("number_of_children", 0)

              }}
            />
          )}
        </div>
        <div className="pr-2">
          <ButtonSubmit href={'#'} onClick={handleSubmit} />
        </div>
      </div>

      {isOpen && (
        <div className="h-8 absolute self-center top-1/2 -translate-y-1/2 z-0 -left-0.5 right-10 bg-white dark:bg-neutral-800"></div>
      )}

      {isOpen && (
        <div className="absolute right-0 z-30 w-full sm:min-w-[340px] max-w-sm bg-white dark:bg-neutral-800 top-full mt-3 py-5 sm:py-6 px-4 sm:px-8 rounded-3xl shadow-xl">
          <NcInputNumber
            className="w-full"
            defaultValue={guestAdultsInputValue}
            onChange={(value) => handleChangeData(value, "guestAdults")}
            max={10}
            min={1}
            label="Adults"
            desc="Ages 13 or above"
          />
          <NcInputNumber
            className="w-full mt-6"
            defaultValue={guestChildrenInputValue}
            onChange={(value) => handleChangeData(value, "guestChildren")}
            max={4}
            label="Children"
            desc="Ages 2–12"
          />

          <NcInputNumber
            className="w-full mt-6"
            defaultValue={guestInfantsInputValue}
            onChange={(value) => handleChangeData(value, "guestInfants")}
            max={4}
            label="Infants"
            desc="Ages 0–2"
          />
        </div>
      )}
    </div>
  );
};

export default GuestsInput;
